export function getAccountType(accountTypeId, accountTypesList) {
  const filteredList = accountTypesList?.find(value => value?.AccountTypeId === accountTypeId);
  return filteredList?.AccountType;
}
